import { h } from "preact";
import { useRef, useEffect } from "preact/hooks";

export default function BlogCardVideo({ video, className, play }) {
  const { sources, previewImage } = video;
  const videoRef = useRef(null);

  // In the future we could check the element size and pick a suitable source but for now we're
  // just sorting and grabbing the smallest one.
  const mp4s = sources
    .filter((source) => source.format === "mp4")
    .sort((a, b) => a.width - b.width);

  useEffect(() => {
    if (videoRef?.current) {
      if (play) {
        videoRef.current.play();
      } else {
        videoRef.current.pause();
      }
    }
  }, [play]);

  return (
    <video
      className={className}
      src={mp4s[0].url}
      poster={getSizedImageUrl(previewImage.url, "x800")}
      muted
      preload="none"
      playsinline
      ref={videoRef}
    ></video>
  );
}
